import React from 'react';
import { ReclassificationInfo } from '../types';

interface ReclassificationBadgeProps {
  info: ReclassificationInfo | null;
}

const ReclassificationBadge: React.FC<ReclassificationBadgeProps> = ({ info }) => {
  if (!info) return null;

  const stars = '★'.repeat(info.reviewStars) + '☆'.repeat(Math.max(0, 4 - info.reviewStars));

  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {/* Star rating */}
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-slate-100 text-xs">
        <span className="text-amber-500 tracking-tight">{stars}</span>
      </span>

      {/* Submitter count */}
      <span className="text-xs text-slate-400">
        {info.submitterCount} submitter{info.submitterCount !== 1 ? 's' : ''}
      </span>

      {/* Reclassification alert */}
      {info.hasBeenReclassified && info.previousClassification && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-amber-50 border border-amber-200 text-xs font-medium text-amber-700">
          ⬆️ {info.previousClassification} → {info.currentClassification}
          {info.reclassificationDate && (
            <span className="text-amber-500 font-normal ml-1">({info.reclassificationDate})</span>
          )}
        </span>
      )}

      {/* Last evaluated */}
      {info.lastEvaluated && (
        <span className="text-xs text-slate-400">
          Last reviewed: {info.lastEvaluated}
        </span>
      )}
    </div>
  );
};

export default ReclassificationBadge;
